<div class="container-fluid">
  <h1 class="text-2xl font-bold mb-4">
    @if (isCreateMode) { Cadastro de usuário } @else { Alterar usuário }
  </h1>

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  @if (loading) {
    <div class="mb-4">
      <app-loading size="large" color="primary"/>
    </div>
  }

  @if (!loading) {
    <form [formGroup]="userForm" (ngSubmit)="submit()" class="space-y-4 max-w-3xl">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Nome de usuário</label>
          <input type="text" class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-slate-600 dark:border-neutral-900 dark:focus:border-slate-600 focus:ring-0" formControlName="userName" />
          @if (userForm.get('userName')?.invalid && userForm.get('userName')?.touched)
          {
            <div class="text-red-500 text-sm mt-1">{{ 'USERS.ERRORS.INVALID_USERNAME' | translate }}</div>
          }
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">E-mail</label>
          <input type="email" class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-slate-600 dark:border-neutral-900 dark:focus:border-slate-600 focus:ring-0" formControlName="email" />
          @if (userForm.get('email')?.invalid && userForm.get('email')?.touched)
          {
            <div class="text-red-500 text-sm mt-1">{{ 'USERS.ERRORS.INVALID_EMAIL' | translate }}</div>
          }
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Grupo de usuário</label>
          <select class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-slate-600 dark:border-neutral-900 dark:focus:border-slate-600 focus:ring-0" formControlName="userGroup">
            <option [ngValue]="null" disabled>Selecione um grupo</option>
            @for (g of groups; track g.id) {
              <option [ngValue]="g.id">{{ g.name }}</option>
            }
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Roles do grupo</label>
          @if (roles.length) {
            <ul class="list-disc list-inside text-sm">
              @for (r of roles; track r) {
                <li>{{ r }}</li>
              }
            </ul>
          } @else {
            <p class="text-sm text-gray-400">Nenhuma role para exibir.</p>
          }
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Nome completo</label>
          <input type="text" class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-slate-600 dark:border-neutral-900 dark:focus:border-slate-600 focus:ring-0" formControlName="realName" />
          @if (userForm.get('realName')?.invalid && userForm.get('realName')?.touched)
          {
            <div class="text-red-500 text-sm mt-1">{{ 'USERS.ERRORS.INVALID_REAL_NAME' | translate }}</div>
          }
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Documento</label>
          <input type="text" class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-slate-600 dark:border-neutral-900 dark:focus:border-slate-600 focus:ring-0" formControlName="document" />
          @if (userForm.get('document')?.invalid && userForm.get('document')?.touched)
          {
            <div class="text-red-500 text-sm mt-1">{{ 'USERS.ERRORS.INVALID_DOCUMENT' | translate }}</div>
          }
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Data de nascimento</label>
          <input type="date" class="form-input w-full py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-slate-600 dark:border-neutral-900 dark:focus:border-slate-600 focus:ring-0" formControlName="birthday" />
          @if (userForm.get('birthday')?.invalid && userForm.get('birthday')?.touched)
          {
            <div class="text-red-500 text-sm mt-1">{{ 'USERS.ERRORS.INVALID_BIRTHDATE' | translate }}</div>
          }
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <input class="form-checkbox rounded border-gray-200 dark:border-neutral-900 text-neutral-600 focus:border-neutral-600/30 focus:ring focus:ring-offset-0 focus:ring-neutral-600/20 focus:ring-opacity-50 me-2" type="checkbox" formControlName="enabled" id="RememberMe">
          <label class="form-checkbox-label" for="RememberMe">Ativo</label>
        </div>
      </div>

      <div class="flex gap-2 pt-4">
        <app-button type="submit" rounded="full" color="primary" size="medium" [loading]="submitting" [disabled]="submitting">
          {{ 'Salvar alterações' | translate }}
        </app-button>
        <app-button type="button" color="secondary" size="medium" rounded="full" (click)="cancel()">Cancelar</app-button>
      </div>
    </form>
  }
</div>
